import React, { useState, useEffect } from 'react';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import ToggleButton from './ToggleButton';
import ToggleContent from './ToggleContent';
import { css } from 'emotion';
import EirButton from '../eir-button/EirButton';
import { LargeBusiness, moduleMargins, htmlWidget } from '../../Constants';


function EirBundleCardToggle(props) {

    const renderContent = (content) => {
        return { __html: content };
    }

    //To get background based on device
    const getBackgroundImage = () => {
        if (isMobile && !isTablet) {
            return (props.mobileBackgroundImage) ? props.mobileBackgroundImage.path : '';
        }
        return (props.backgroundImage) ? props.backgroundImage.path : '';
    }

    const getBackgroundColor = () => {
        if (isMobile && !isTablet) {
            return (props.mobilebackgroundColor) ? props.mobilebackgroundColor : '';
        }
        return (props.backgroundColor) ? props.backgroundColor : '';
    }

    //const lbBundleCard = LargeBusiness.isLBSite ? "eir-bundle-card-toggle eir-lb-bundle-card-toggle" : "eir-bundle-card-toggle";

    let [marginDesktop, marginMobile] = moduleMargins(props.MarginDT, props.MarginMobile);
    const bundleToggleProps = {
        marginClass : (!isMobile) ? marginDesktop : marginMobile,
        lbBundleCard : LargeBusiness.isLBSite ? "eir-bundle-card-toggle eir-lb-bundle-card-toggle" : "eir-bundle-card-toggle"
    }

    // console.log("props margins:",props.MarginDT, props.MarginMobile, bundleToggleProps)

    return (
        <div id={"bundle-card-tiles-ctr-" + props.ComponentOccurence} className={`${bundleToggleProps.lbBundleCard} ${bundleToggleProps.marginClass}`}>
            <div className='pt-4 pb-5 bundle-card-container' style={{
                backgroundImage: "url(" + getBackgroundImage() + ")",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundColor: getBackgroundColor(),
            }} >
                <div>
                    {props.Title != undefined && props.Title.length > 0 &&
                        <div className={`${htmlWidget} bundle-card-title container`} dangerouslySetInnerHTML={renderContent(props.Title)}></div>
                    }
                    {props.enableToggleButton == true &&
                        <ToggleButton
                            id={"bundle-card-tiles-ctr-" + props.ComponentOccurence}
                            toggle={props} />}
                </div>
                {props.enableToggleButton == false &&
                    <ToggleContent
                        id={"bundle-card-tiles-ctr-" + props.ComponentOccurence}
                        toggle={props.EirToggleButton[0]} 
                        backgroundColor={props.backgroundColor}
                        />}

                {props.BottomTextCopy != undefined && props.BottomTextCopy.length > 0 &&
                    <div className={htmlWidget + ' d-flex align-items-center justify-content-center toggle_button_bottomTextCopy copy-lb'} dangerouslySetInnerHTML={renderContent(props.BottomTextCopy)}></div>
                }

                {props.BottomCTA &&
                    <div className={'d-flex align-items-center justify-content-center mb-3'}>
                        <EirButton {...props.BottomCTA} databundlecode='bundle card bottom cta' 
                        className={'bundle_card_bottom_cta ' + (!isMobile ?
                                    css` color: ${props.BottomCTAFontColor};
                                    background: ${props.BottomCTABackgroundColor}; 
                                    border-color: ${props.BottomCTAOutlineColor}; 
                                    &:hover, &:focus, &:focus-within, &:active {background: ${props.BottomCTABackgroundHoverColor} !important;
                                    border-color: ${props.BottomCTAOutlineHoverColor} !important;
                                    color: ${props.BottomCTAFontHoverColor}}` :

                                    css` color: ${props.BottomCTAFontColor};
                                    background: ${props.BottomCTABackgroundColor};
                                    border-color: ${props.BottomCTAOutlineColor}; 
                                    &:hover, &:focus, &:focus-within, &:active {background: ${props.BottomCTABackgroundColor} !important;
                                    border-color: ${props.BottomCTAOutlineColor} !important; 
                                    color: ${props.BottomCTAFontColor}}`)} 
                         />
                    </div>
                }

            </div>

        </div>
    );
}
export default EirBundleCardToggle;

